export enum SELECT_SHIPPING_METHOD_TRANSITIONS {
  FETCH_METHODS = 'FETCH_METHODS',
  SYNC_CART_DONE = 'SYNC_CART_DONE',
  SELECT_SHIPPING_ADDRESS = 'SELECT_SHIPPING_ADDRESS',
  SELECT_HOME_METHOD = 'SELECT_HOME_METHOD',
  SELECT_CLICK_AND_COLLECT_METHOD = 'SELECT_CLICK_AND_COLLECT_METHOD',
  SELECT_PICKUP_METHOD = 'SELECT_PICKUP_METHOD',
  SELECT_PICKUP_POINT = 'SELECT_PICKUP_POINT',
  SELECT_COURIER_METHOD = 'SELECT_COURIER_METHOD',
  SELECT_TIME_SLOT = 'SELECT_TIME_SLOT',
  SEND_TO_PARENT = 'SEND_TO_PARENT',
  SET_DELIVERY_INFOS = 'SET_DELIVERY_INFOS',
}
